// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4pBc0","content":"styles_content__3Kn5W","row":"styles_row__1Gh0u","footer":"styles_footer__3YG74","phraseLength":"styles_phraseLength__2ZJw7"};